module.exports = __webpack_public_path__ + "static/img/td.a0923ddc.svg";